var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rate)?_c('label',{staticClass:"checkout-delivery-rate"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"name"},[_c('break-lines',{attrs:{"lines":_vm.replacements,"text":_vm.rate.name}})],1),_vm._v(" "),_c('price-format',{attrs:{"currency":_vm.$store.state.currency.base,"price":_vm.rate.cost}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }